// This reducer is a no-op, only relying on the extra initial state passed to configureStore()
const noop = (state = {}) => state;
export default noop;